// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Divider,
    Fab,
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDoctag } from '../../../../api/helper';
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../../components/ToastProvider';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();
    const { showToast, hideToast } = useToast();

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [openProductDialog, setOpenProductDialog] = useState<boolean>(false)
    const [listProduct, setListProduct] = useState<any[]>([])
    const [valBarang, setValBarang] = useState<any>(null)
    const [listBarangWo, setListBarangWo] = useState<any[]>([])

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdcust_id: any,
        tgl: any,
        tgl_close: any,
        tgl_kirim: any,
        keterangan: any,
        sdproduct_id: any,
        product: any,
        qty: any,
        pic: any,
        mmbarang_id: any,
    }

    const defaultValues = {
        syscabang_id: cabang,
        sdcust_id: 100,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
        tgl_close: new Date(new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).setDate(new Date().getDate() + 7)).toISOString().substring(0, 16),
        tgl_kirim: new Date(new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).setDate(new Date().getDate() + 7)).toISOString().substring(0, 16),
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.permintaan17, cabang, token);
            if(response.length > 0 && response.length == 1){
                setValDoctag(response[0])
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        fetchDoctag();
    }, [])
    
    const getProduct = (jenisProduct:any) => {
        if(jenisProduct == ''){
            showToast('Silahkan pilih jenis product terlebih dahulu', 'warning');
            return;
        }
        
        const url = apiUrl.apiUrl + '/production/work-order/list-product/' + jenisProduct
        axios.get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                setListProduct(data)
            } else {
                showToast(response.data.message, 'error');
            }
        })
    }
    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue ? newValue.id : null)
        setValDoctag(newValue )
    }

    const handleChangeAutocompleteBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_id', newValue ? newValue.id : null)
        setValBarang(newValue)
    }

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/production/permintaan-preview/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/production/permintaan-preview/detail/' + response.data.data)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const convertComponent = [
        {
            key: 'link',
            minWidth: 300,
            renderCell: ({ row }: any) => {
                const url = row.data?.link;
    
                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }
    
                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 400,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                        didClose: () => {
                            setOpenProductDialog(true);
                        }
                    });
                };
    
                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenProductDialog(false);
                            openImage()
                        }}
                    />
                );
            }
        }
    ];
    
    const getListBarangWo = () => {
        const url = apiUrl.apiUrl + '/mm/barang/list-barang-wo/'+getValues('sdproduct_id')
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    if(data.length==1){
                        setValBarang(data[0]);
                        setValue('mmbarang_id',data[0].id)
                    }
                    setListBarangWo(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    
    const rowClickProduct = (e: any) => {
        const data = e.data
        setValue('sdproduct_id', data?.id)
        setValue('product', data?.kode+" || "+data?.nama_product)
        setOpenProductDialog(false)
        getListBarangWo();
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Permintaan Preview Gudang 17
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        getOptionLabel={(option: any) => option?.nama || ""}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={5} sm={5}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='product'
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                label='Product'
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Fab color='info' size='medium' onClick={() => {
                                    getProduct('MLFG');
                                    setOpenProductDialog(true);
                                }}
                                >
                                    <Icon icon='mdi:search' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarang}
                                                options={listBarangWo}
                                                id='barang'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                getOptionLabel={(option: any) => option?.nama || ""}
                                                onChange={handleChangeAutocompleteBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        label='Barang'
                                                        error={Boolean(errors.mmbarang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1}>
                                <Fab color='primary' size='medium' onClick={() => {
                                    if(getValues('sdproduct_id') == null) {
                                        showToast('Silahkan pilih product terlebih dahulu', 'warning');
                                        return;
                                    }
                                        
                                    Swal.fire({
                                        title: 'Tambah Barang',
                                        input: 'text',
                                        inputLabel: 'Nama Barang',
                                        inputPlaceholder: 'Masukkan nama barang',
                                        showCancelButton: true,
                                        confirmButtonText: 'Simpan',
                                        cancelButtonText: 'Batal',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Form ini tidak boleh kosong.'
                                            }
                                        }
                                    }).then(result => {
                                        if (result.isConfirmed && result.value) {
                                            const barang = result.value;
                                            const data = { barang };
                                            const url = apiUrl.apiUrl + '/mm/barang/add-barang-work-order/'+getValues('sdproduct_id');
                                            axios
                                                .post(url, data, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    if (response.data.success) {
                                                        showToast(response.data.message, 'success');
                                                        getListBarangWo();
                                                    } else {
                                                        showToast(response.data.message, 'error');
                                                    }
                                                })
                                                .catch(error => {
                                                    showToast(error.message, 'error');
                                                });
                                        }
                                    });
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='number'
                                                value={value || ''}
                                                label='Qty'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* 
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_close'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal Close'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_close)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_close && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal Close harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kirim'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal Kirim'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_kirim)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_kirim && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal Kirim harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openProductDialog}
                onClose={() => setOpenProductDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List Product MLFG
                    </Typography>
                </DialogTitle>
                <DialogContent  dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listProduct} rowClick={rowClickProduct} customRender={convertComponent} hiddenColumns={['id']} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenProductDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
